<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-form ref="form" :model="detailForm" label-width="140px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="群封面">
              <el-image v-if="showDefaultImage(detailForm.groupIcon)" :src="imageGroupUrl"></el-image>
              <el-image v-model="detailForm.groupName" v-if="detailForm.groupIcon" :key="detailForm.groupIcon"
                        :src="getImageUrl(detailForm.groupIcon)"></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="群封面上传">
              <el-upload
                  ref="upload"
                  :http-request="getOSSUploadInfo"
                  action=""
                  show-file-list:false
                  accept=".jpg,.png"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :on-change="onChange"
                  :on-remove="onRemove"
                  :file-list="uploadFileList"
                  :before-upload="beforeUpload"
                  :auto-upload="true"
              >
                <el-button slot="trigger" size="small" type="primary" :disabled="!judgeCreator">
                  上传
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="标签">
              <span v-if="detailForm.tagList===[]">无</span>
              <el-tag
                  v-for="tag in detailForm.tagList"
                  :key="tag.tagName"
                  :type="tag.tagName"
              >
                {{ tag.tagName }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="群名称">
              <el-input v-model="detailForm.groupName" :disabled="!judgeCreator"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建者">
              <el-input v-model="detailForm.nickname" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建时间">
              <el-input v-model="detailForm.createTime" disabled/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="非群成员权限">
              <el-select
                  v-model="detailForm.accessAuthority"
                  placeholder="请选择活动区域"
                  style="width: 100%"
                  :disabled="!judgeCreator"
                  @change="changeAccessAuthority"
              >
                <el-option label="不能进群" :value="0"/>
                <el-option label="可以进群但不能发言" :value="1"/>
                <el-option label="可以进群且可以发言" :value="2"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="群组类型">
              <el-select
                  v-model="detailForm.groupType"
                  placeholder="请选择活动区域"
                  style="width: 100%"
                  :disabled="!judgeCreator"
                  @change="changeGroupType"
              >
                <el-option label="公开" :value="0"/>
                <el-option label="私有" :value="1"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="userDataTypeOptions.length > 0" :span="6">
            <el-form-item label="所属领域">
              <el-select
                  v-model="detailForm.userDataType"
                  placeholder="请选择活动区域"
                  style="width: 100%"
                  :disabled="!judgeCreator"
                  @change="changeUserDataType"
              >
                <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value"
                           :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="推荐">
              <el-switch v-model="detailForm.showType" :active-value=1 :inactive-value=0
                         @change="setForums(detailForm, 2)"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否加群需要认证">
              <el-switch v-model="detailForm.isNeedVerify" :active-value=true :inactive-value=false
                         @change="setForums(detailForm, 1)"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="验证码">
              <el-input v-model="detailForm.invitationCode" :disabled="!judgeCreator" maxlength="6"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
<!--          <el-col :span="6">-->
<!--            <el-form-item label="热度值">-->
<!--              <el-input v-model="detailForm.heatValue" disabled/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="6">
            <el-form-item label="帖子数">
              <el-input v-model="detailForm.forumSum" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="成员数">
              <el-input v-model="detailForm.memberSum" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="群简介">
          <el-input v-model="detailForm.groupProfile" type="textarea" rows="4" :disabled="!judgeCreator"/>
        </el-form-item>
        <el-form-item>
          <el-button
              size="small"
              :type="detailForm.isDeleted ? 'warning' : 'danger'"
              @click.stop="deleteOrBackGroup(detailForm)"
          >
            {{ detailForm.isDeleted ? "恢复群组" : "删除群组" }}
          </el-button>
          <el-button type="primary" size="small" @click="onSubmit" :disabled="!judgeCreator">
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {getOne, updateForumGroups} from '@/api/ultrasonicGroupsDetail'
import {getCloudUrl} from "@/utils/urlutil"
import {deleteOrBackForumGroup, deleteOrBackForums, updateForumGroup} from "@/api/ultrasonic";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import defaultImage from "/src/assets/images/grouplogo.png";
import {getUserType} from "@/utils/userutil";

export default {
  props: {
    ForumGroupID: {
      Number
    },
    part: {
      String
    },
    title: {
      String
    },
    judgeCreator: {
      Boolean
    }
  },
  data() {
    return {
      userDataTypeOptions: [],
      imageGroupUrl: defaultImage,
      // ForumGroupID: null,
      // judgeCreator: false,
      detailForm: [],
      // title: '',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        // part: null
      },
      tags: [
        {name: '标签一', type: ''},
        {name: '标签二', type: 'success'},
        {name: '标签三', type: 'info'},
        {name: '标签四', type: 'warning'}
      ],
      ossInfo: "",          // OSS信息
      ossPath: "",          // OSS路径
      uploadFileList: [],
      fileFormat: null,
      fileType: 0, //文件类型
    }
  },
  created() {
    this.userDataTypeOptions = getUserType()
    this.getOne();
  },


  methods: {
    showDefaultImage(url) {
      if (url === null || url === "") {
        return true;
      }
      return false;
    },
    /**
     * 获取OSS上传信息
     *
     * @param {object} file 文件对象
     */
    getOSSUploadInfo(file) {
      const params = {
        DataType: "8",
        ID: this.ForumGroupID,
      };
      getOSSUploadInfo(params).then((res) => {
        this.ossInfo = res.resultData.AssumeRoleToken;
        this.ossPath = res.resultData.PicSavePath;
        this.uploadFile(file);
      });
    },
    /**
     * 上传服务器
     *
     * @param {object} file 文件对象
     */
    uploadFile(file) {
      const uploadFile = file.file; // 获取上传的file对象
      const uploadFileSize = uploadFile.size / 1024 / 1024; // 获取上传文件的大小，单位 MB
      this.multipartUpload(file, uploadFileSize);
    },
    /**
     * 分片上传
     */
    async multipartUpload(file, uploadFileSize) {
      let OSS = require("ali-oss");
      // 实例化OSS Client。
      let client = new OSS({
        region: this.config.OSS_END_POINT,
        accessKeyId: this.ossInfo.AccessKeyId,
        accessKeySecret: this.ossInfo.AccessKeySecret,
        stsToken: this.ossInfo.SecurityToken,
        bucket: this.config.OSSBUCKET,
        timeout: 600000,
      });

      const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p) => {
          //p进度条的值
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 1024 * 1024,
      };
      let timestamp = new Date().valueOf();
      const fileName = file.file.uid + "_" + timestamp;
      var fileUrl = this.ossPath + fileName;
      if (this.fileFormat !== null) {
        fileUrl += "." + this.fileFormat
      }
      client
          .multipartUpload(fileUrl, file.file, options)
          .then((res) => {
            if (res.res.requestUrls) {
              this.addForumFile("/" + fileUrl);

            } else {
              this.$message.error("Upload failed");
            }
          })
          .catch((err) => {
            console.log("Upload OSS Error:", err);
          });
    },
    addForumFile(fileUrl) {
      const temp = {
        forumGroupId: this.ForumGroupID,
        groupIcon: fileUrl
      };
      updateForumGroup(temp).then(() => {
        this.$message({
          type: "success",
          message: "群封面更新成功",
        });
        this.getOne();
      });
    },
    /**.then(() => {
     * 上传限制校验
     *
     * @param {object} file 文件对象
     */
    beforeUpload(file) {
      // 文件类型限制
      let exname = file.name.substring(file.name.lastIndexOf(".") + 1);
      const fileTypes = ["mp4", "jpg", "png"];
      var index = fileTypes.indexOf(exname)
      if (index < 0) {
        this.$message({
          message: "上传文件只能是 MP4 / JPG / PNG 格式",
          type: "warning",
        });
        return false;
      }
      this.fileFormat = fileTypes[index];
      if (index === 0) {
        this.fileType = 1;
      } else {
        this.fileType = 0;
      }

      // 文件大小限制
      const isOverSize = file.size / 1024 / 1024 > 50;
      if (isOverSize) {
        this.$message({
          message: "文件大小不能超过 50MB",
          type: "warning",
        });
        return false;
      }
    },
    /**
     * 上传数量限制提示
     */
    handleExceed() {
      this.$message({
        message: "一次只能上传一个文件",
        type: "warning",
      });
    },
    /**
     * 监听移除文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    onRemove(file, fileList) {
      this.uploadFileList = fileList;
    },
    /**
     * 监听上传文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    onChange(file, fileList) {
      this.uploadFileList = fileList;
    },
    changeAccessAuthority(id) {
      console.log(id);
      this.detailForm.accessAuthority = id;
      this.$forceUpdate()
    },
    changeGroupType(id) {
      console.log(id);
      this.detailForm.groupType = id;
      this.$forceUpdate()
    },
    changeUserDataType(id) {
      console.log(id);
      this.detailForm.userDataType = id;
      this.$forceUpdate()
    },
    deleteOrBackGroup(row) {
      // 判断操作类型
      let tips1, tips2;
      if (row.isDeleted) {
        tips1 = "是否恢复该超人圈群组";
        tips2 = "恢复成功";
      } else {
        tips1 = "是否删除该超人圈群组";
        tips2 = "删除成功";
      }

      const params = {
        forumGroupId: row.forumGroupId,
      };
      this.$confirm(tips1, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            deleteOrBackForumGroup(params).then(() => {
              this.$message({
                type: "success",
                message: tips2,
              });
              this.refreshCurrentList();
            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },
    /**
     * 设置帖子状态
     *
     * @param {object} row 所选对象信息
     * @param {number} type 所选状态类型
     */
    setForums(row, type) {
      const params = {
        forumGroupId: row.forumGroupId,
      };
      if (type === 2) {
        console.log(row)
        console.log(row.showType.toString())
        if (1 === row.showType) {
          params.showType = 1
        } else {
          params.showType = 0;
        }
      } else if (type === 1) {
        params.isNeedVerify = row.isNeedVerify !== false;
        if (params.isNeedVerify === true) {
          params.invitationCode = row.invitationCode;
        }
      } else if (type === 0) {
        params.isNeedCodeConfirm = row.isNeedCodeConfirm === 1 ? 0 : 1;
      }
      updateForumGroups(params).then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.getOne();
      });

    },

    getOne() {
      const params = {
        forumGroupId: this.ForumGroupID
      };
      getOne(params).then(res => {
        this.detailForm = res.data
      });
      this.$forceUpdate();
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    onSubmit() {
      const temp = {
        forumGroupId: this.ForumGroupID,
        accessAuthority: this.detailForm.accessAuthority,
        groupName: this.detailForm.groupName,
        groupProfile: this.detailForm.groupProfile,
        groupType: this.detailForm.groupType,
        userDataType: this.detailForm.userDataType
      };
      updateForumGroup(temp).then(() => {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.getOne();
      });
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
